import { render } from "./HDadd.vue?vue&type=template&id=56bf38f7&scoped=true"
import script from "./HDadd.vue?vue&type=script&lang=js"
export * from "./HDadd.vue?vue&type=script&lang=js"

import "./HDadd.vue?vue&type=style&index=0&id=56bf38f7&lang=scss&scoped=true"
import "./HDadd.vue?vue&type=style&index=1&id=56bf38f7&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56bf38f7"]])

export default __exports__